var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelfLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 68 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.05.048h20.101v19.811H.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 29.683h68V.106H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 21.215h5.728c.042 2.047 2.02 3.726 4.657 3.726 2.556 0 4.245-1.31 4.245-3.316 0-1.556-1.154-2.661-3.585-3.398l-3.462-.983C1.36 15.607.247 11.881.247 9.344.247 4.307 4.616.95 10.056.95c5.357 0 9.479 3.234 9.479 8.597h-5.729c0-2.006-1.401-3.562-3.874-3.562-2.225 0-3.915 1.351-3.915 3.234 0 .696.206 2.17 3.173 2.989l3.174.9c4.286 1.188 8.036 3.44 8.036 8.23 0 5.608-4.822 8.555-10.18 8.555C4.163 29.894 0 26.21 0 21.215"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.038 9.824)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.777 8.265c-.164-2.237-2.05-3.58-4.471-3.58-2.175 0-4.103 1.018-4.677 3.58h9.148Zm5.292 3.458H5.63c.574 2.197 2.38 3.417 4.964 3.417 1.928 0 3.856-.773 5.005-2.115l3.159 3.132c-1.805 2.4-5.17 3.702-8.533 3.702C4.357 19.86.05 15.873.05 10.015.05 3.872 4.726.048 10.224.048c5.456 0 9.927 3.824 9.927 9.641 0 .53-.04 1.18-.082 2.034Z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M42.5 29.472h5.313V.317H42.5zM58.022 9.247v1.223h4.16v4.119h-4.16v14.883h-5.344V14.589h-3.59V10.47h3.59V9.288c0-5.709 2.937-8.971 8.362-8.971h2.285v4.975h-1.224c-3.06 0-4.039 1.671-4.08 3.955",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BD1FF",
    d: "M61.2 26.177c0-1.871 1.538-3.254 3.36-3.254 1.861 0 3.44 1.383 3.44 3.254 0 1.912-1.579 3.295-3.44 3.295-1.822 0-3.36-1.383-3.36-3.295",
    mask: "url(#d)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfLogo);
export default __webpack_public_path__ + "static/media/self-logo.9c9f516c1062e9ab9d28586caed10f2d.svg";
export { ForwardRef as ReactComponent };